import * as type from './SearchType';

const initialState = {
    fields: [
        {
            index: 1
        }
    ],
    searchResult: null,
    isSearched: false,
    total: null,
    reports: null,
    selectValue: []
    // this state used to replace id with value in selectField
};

export const searchReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.ADD_NEW_FIELD:
            return { ...state, fields: [...state.fields, { index: action.payload }] };
        case type.ADD_STRUCTURE: {
            const { index, id } = action.payload;
            const fields = state.fields.map((item) =>
                item.index === index ? { ...item, structure: id } : item
            );
            return { ...state, fields };
        }
        case type.ADD_FIELD: {
            const { index, id, name } = action.payload;
            const fields = state.fields.map((item) =>
                item.index === index ? { ...item, field: { id, name } } : item
            );
            return { ...state, fields };
        }
        case type.DELETE_SELECTED_FIELD: {
            const index = action.payload;
            const fields = state.fields.map((item) =>
                item.index === index ? { ...item, field: null } : item
            );
            return {
                ...state,
                fields
            };
        }
        case type.ADD_VALUE: {
            const { index, value, isRange } = action.payload;
            const fields = state.fields.map((item) =>
                item.index === index
                    ? {
                          ...item,
                          index,
                          lookup_type: isRange ? 'range' : 'match',
                          value: value
                      }
                    : item
            );
            return {
                ...state,
                fields: fields
            };
        }
        case type.ADD_SELECT_VALUE: {
            const { name, id } = action.payload;
            const findValue = state.selectValue.find(
                (item) => item.name === name && item.id === id
            );
            const selectValue = state.selectValue.map((item) =>
                item.name === findValue?.name && item.id === findValue?.id ? action.payload : item
            );
            if (findValue?.name) {
                return {
                    ...state,
                    selectValue: selectValue
                };
            }
            return {
                ...state,
                selectValue: [...state.selectValue, action.payload]
            };
        }
        case type.DELETE_VALUE: {
            const index = action.payload;
            const fields = state.fields.map((item) =>
                item.index === index ? { ...item, value: null } : item
            );
            return {
                ...state,
                fields
            };
        }
        case type.ADD_ERROR_MESSAGE: {
            const { index, message } = action.payload;
            const fields = state.fields.map((item) =>
                item.index === index ? { ...item, index, errorMessage: message } : item
            );
            return {
                ...state,
                fields: fields
            };
        }
        case type.DELETE_FIELD: {
            return {
                ...state,
                fields:
                    state?.fields?.length === 1
                        ? [{ index: 1 }]
                        : state.fields.filter((item) => item.index !== action.payload)
            };
        }
        case type.RESET_FIELDS:
            return {
                ...state,
                ...initialState
            };
        case type.IS_SEARCHED:
            return { ...state, isSearched: false };
        case type.SEARCH_FORM_SUCCESS: {
            const data = action.payload;
            const result = data?.map((item) => ({
                ...item,
                indicator_fields: item?.indicator_fields
                    ? [...Object.values(item.indicator_fields)]
                    : []
            }));
            const unique = result.map((item) => ({
                ...item,
                indicator_fields: item.indicator_fields.filter(function (o) {
                    const [k] = Object.keys(o);
                    return this[k] ? false : (this[k] = 1);
                }, {})
            }));
            return { ...state, searchResult: unique, isSearched: true, total: action.total };
        }
        case type.GET_SEARCH_REPORT:
            return { ...state, reports: action.payload.results };
        case type.DELETE_SEARCH_REPORT:
            return {
                ...state,
                reports: state.reports.filter((item) => item.id !== action.payload)
            };
        default:
            return state;
    }
};
